import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "./HomeBanner.css";
import BannerTitle from "../../font_component/banner_title/BannerTitle";
import { useDispatch, useSelector } from "react-redux";
import { AllBanners } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";

const images = [
  "/images/home/banner_image/img1.png",
  "/images/home/banner_image/img2.png",
];

export default function HomeBanner() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const dispatch = useDispatch();

  const all_banners = useSelector((state) => state?.common?.all_banners);

  useEffect(() => {
    dispatch(AllBanners());
  }, [dispatch]);

  return (
    <section>
      <div className="home-banner">
        {/* <Swiper
  direction="vertical"
  modules={[Navigation]}
  loop={true}
  autoHeight={false}
  observer={true}
  observeParents={true}
  watchSlidesProgress={true}
  className="banner-swiper"
  navigation={{
    prevEl: prevRef.current,
    nextEl: nextRef.current,
  }}
  onBeforeInit={(swiper) => {
    swiper.params.navigation.prevEl = prevRef.current;
    swiper.params.navigation.nextEl = nextRef.current;
  }}
> */}

        <Swiper
          direction="vertical"
          modules={[Navigation]}
          loop={true}
          className="banner-swiper"
          navigation={{
            prevEl: ".custom-prev",
            nextEl: ".custom-next",
          }}
        >
          {all_banners.map((img, index) => (
            <SwiperSlide key={img.id || index}>
              <div className="banner-slide">
                <img
                  src={`${IDS.IMG_URL}${img.banner}`}
                  alt={`Banner ${index + 1}`}
                  className="banner-image"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="curve_img_div">
          <img
            src="/images/home/banner_image/white patch.png"
            className="curve_img"
            alt=""
          />
        </div>

        <div className="overlay"></div>

        {/* Navigation */}
        <div className="banner-nav">
          <button
            ref={prevRef}
            className="banner-nav-btn custom-prev"
            aria-label="Previous slide"
          >
            <span className="banner-arrow banner-arrow-up"></span>
          </button>

          <button
            ref={nextRef}
            className="banner-nav-btn custom-next"
            aria-label="Next slide"
          >
            <span className="banner-arrow banner-arrow-down"></span>
          </button>
        </div>

        {/* Content */}
        <div className="banner-content">
          <BannerTitle
            firstText="Fuel Your Body with"
            highlightText="Spirulina"
            bannerSubText="100% natural, nutrient-rich superfood for a healthier lifestyle."
          />
        </div>
      </div>
    </section>
  );
}
